/**
 * ARKS Store - Predictive Search Handler
 */

class ARKSPredictiveSearch {
  constructor() {
    this.searchForm = document.querySelector('.header-search-form');
    this.searchInput = document.querySelector('.header-search-input');
    this.resultsContainer = document.querySelector('#PredictiveSearchResults');
    this.debounceTimer = null;

    this.init();
  }

  init() {
    if (!this.searchInput || !this.resultsContainer) return;

    this.searchInput.addEventListener('input', () => {
      clearTimeout(this.debounceTimer);
      const query = this.searchInput.value.trim();

      if (query.length < 2) {
        this.closeResults();
        return;
      }

      this.debounceTimer = setTimeout(() => {
        this.fetchSuggestions(query);
      }, 250);
    });

    document.addEventListener('click', (e) => {
      if (!this.searchForm.contains(e.target)) {
        this.closeResults();
      }
    });
  }

  async fetchSuggestions(query) {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`);
      if (!response.ok) return;

      const data = await response.json();
      const products = data.resources.results.products;
      this.renderResults(products, query);
    } catch (err) {
      console.error('Predictive search fetch error:', err);
    }
  }

  renderResults(products, query) {
    if (!products || products.length === 0) {
      this.resultsContainer.innerHTML = `
        <div style="padding: 12px; text-align: center; color: var(--color-text-secondary); font-size: 0.9rem;">
          No products found for "${query}".
        </div>
      `;
      this.openResults();
      return;
    }

    let html = '<div class="predictive-search-list">';
    products.forEach(p => {
      const currency = window.ARKS_CONFIG ? window.ARKS_CONFIG.currencySymbol : '₹';
      const priceFormatted = `${currency}${p.price}`;

      html += `
        <a href="${p.url}" class="predictive-search-item">
          <img src="${p.image || ''}" alt="${p.title}" class="predictive-search-image" loading="lazy">
          <div class="predictive-search-info">
            <div class="predictive-search-title">${p.title}</div>
            <div class="predictive-search-price">${priceFormatted}</div>
          </div>
        </a>
      `;
    });

    html += `
      <div style="margin-top: 10px; padding-top: 10px; border-top: 1px solid var(--color-border); text-align: center;">
        <a href="/search?q=${encodeURIComponent(query)}" class="view-all-link" style="font-size: 0.88rem;">
          View all results for "${query}" &rarr;
        </a>
      </div>
    </div>`;

    this.resultsContainer.innerHTML = html;
    this.openResults();
  }

  openResults() {
    this.resultsContainer.classList.add('is-open');
  }

  closeResults() {
    if (this.resultsContainer) {
      this.resultsContainer.classList.remove('is-open');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.ARKS_Search = new ARKSPredictiveSearch();
});
